import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import {Divider, Grid} from "@material-ui/core";
import {usePackagesStyles} from "./useStyles";

const PackageItemSkeleton = () => {
    const classes = usePackagesStyles();

    return(
        <Grid item className={classes.gridItem}>
            <div className={classes.skeletonCard}>
                <div>
                    <Skeleton variant="text" width="60%" height={24} style={{ margin: '0 auto' }} />
                    <Skeleton variant="text" width="80%" height={40} style={{ margin: '8px auto' }} />
                    <Skeleton variant="text" width="50%" height={20} style={{ margin: '0 auto' }} />
                    <Divider style={{ margin: '16px 0' }} />
                    <Skeleton variant="text" width="90%" height={20} style={{ marginLeft: '10px' }} />
                    <Skeleton variant="text" width="90%" height={20} style={{ marginLeft: '10px' }} />
                    <Skeleton variant="text" width="90%" height={20} style={{ marginLeft: '10px' }} />
                </div>

                <Skeleton variant="rect" width={'100%'} height={36} style={{ margin: '16px auto', borderRadius: '7px' }} />
            </div>
        </Grid>
    );
};

export default PackageItemSkeleton;